<div class="comparables-leases-container">

  <loading-indicator [show]="loading"></loading-indicator>

  <div class="main-table-title">{{'comparables.leases' | translate | uppercase}}</div>
  <div class="grid-wrapper-outer">
    <div class="grid-wrapper-inner">
      <kendo-grid #kendoGrid class="grid-v2"
                  (dataStateChange)="dataStateChanged($event)"
                  [pageable]="true"
                  [pageSize]="state.take"
                  [data]="gridDataResult"
                  [skip]="state.skip"
                  [sortable]="true"
                  [sort]="state.sort"
                  [groupable]="false"
                  [filterable]="true"
                  [resizable]="true"
                  [selectable]="selectableSettings"
                  [filter]="state.filter"
                  (selectionChange)="onRowSelected($event)"
                  (cellClick)="onCellClick($event)"
                  (dblclick)="onDoubleClicked($event)"
                  kendoGridSelectBy="oid"
                  [(selectedKeys)]="selectedItems"
                  [columnMenu]="columnMenuSettings"
                  [reorderable]="true"
                  (columnReorder)="columnReordered($event)"
                  (columnResize)="columnResized($event)"
                  (columnVisibilityChange)="columnVisibilityChanged($event)"
                  [rowClass]="rowClassCallback">
        <kendo-grid-excel fileName="Leases.xlsx" [fetchData]="getExcelExportData(2000)">
          <ng-container *ngFor="let col of columns; trackBy: trackByField">
            <kendo-excelexport-column *ngIf="col.field !== 'checkbox'" [field]="col.field" [title]="col.title | translate">
            </kendo-excelexport-column>
          </ng-container>
        </kendo-grid-excel>

        <ng-template kendoGridColumnMenuTemplate let-service="service">
          <div class="grid-v2-column-menu">
            <kendo-grid-columnmenu-sort [service]="service">
            </kendo-grid-columnmenu-sort>
            <kendo-grid-columnmenu-chooser [service]="service">
            </kendo-grid-columnmenu-chooser>
            <kendo-grid-columnmenu-filter [service]="service">
            </kendo-grid-columnmenu-filter>
          </div>
        </ng-template>

        <kendo-grid-column *ngFor="let col of columns; trackBy: trackByField"
                           [field]="col.field"
                           [width]="col.width"
                           [sortable]="col.field !== 'checkbox'"
                           [title]="col.title | translate"
                           [columnMenu]="col.field !== 'checkbox'"
                           [headerClass]="{'checkbox-column': col.field === 'checkbox'}"
                           [class]="{'checkbox-column': col.field === 'checkbox'}">

          <ng-template kendoGridHeaderTemplate *ngIf="col.field === 'checkbox'"
                       let-column
                       let-columnIndex="columnIndex">
            <input type="checkbox" id="checkAllComparablesLeases" [(ngModel)]="checkAllChecked" (change)="selectOrDeselectAllCheckbox()" class="k-checkbox" /><label class="k-checkbox-label" for="checkAllComparablesLeases"></label>
          </ng-template>
          <ng-template kendoGridCellTemplate let-dataItem let-rowIndex="rowIndex" *ngIf="col.field === 'checkbox'">
            <div>
              <input type="checkbox" [(ngModel)]="dataItem.checkbox" [attr.id]="'gridCheckboxComparablesLeases' + dataItem.oid" class="gridCheckbox k-checkbox" /><label class="k-checkbox-label checkbox-centering" [attr.for]="'gridCheckboxComparablesLeases' + dataItem.oid"></label>
            </div>
          </ng-template>

          <ng-template kendoGridCellTemplate let-dataItem let-rowIndex="rowIndex" *ngIf="col.type === 'number'">
            {{dataItem[col.field] | number: '1.0-2'}}
          </ng-template>
          <ng-template kendoGridCellTemplate let-dataItem let-rowIndex="rowIndex" *ngIf="col.type === 'number2'">
            {{dataItem[col.field] | number: '1.2-2'}}
          </ng-template>
          <ng-template kendoGridCellTemplate let-dataItem let-rowIndex="rowIndex" *ngIf="col.type === 'date'">
            {{dataItem[col.field] | date: 'dd/MM/yyyy'}}
          </ng-template>
          <ng-template kendoGridCellTemplate let-dataItem let-rowIndex="rowIndex" *ngIf="col.type === 'currency'">
            {{dataItem[col.field] | number: '1.2-2'}} {{dataItem.currencySymbol}}
          </ng-template>
          <ng-template kendoGridCellTemplate let-dataItem let-rowIndex="rowIndex" *ngIf="col.type === 'area'">
            {{dataItem[col.field] | number: '1.2-2'}} {{dataItem.unitOfLengthDescription}}²
          </ng-template>
          <ng-template kendoGridCellTemplate let-dataItem let-rowIndex="rowIndex" *ngIf="col.type === 'currencyPerArea'">
            {{dataItem[col.field] | number: '1.2-2'}} {{dataItem.currencySymbol}} / {{dataItem.unitOfLengthDescription}}²
          </ng-template>
          <ng-template kendoGridCellTemplate let-dataItem let-rowIndex="rowIndex" *ngIf="col.type === 'year'">
            <ng-container *ngIf="dataItem[col.field]">{{dataItem[col.field]}}</ng-container>
          </ng-template>
        </kendo-grid-column>

        <ng-template kendoPagerTemplate
                     let-totalPages="totalPages"
                     let-currentPage="currentPage">
          <kendo-pager-prev-buttons></kendo-pager-prev-buttons>
          <kendo-pager-numeric-buttons [buttonCount]="pagerConfig.numericButtonsCount"></kendo-pager-numeric-buttons>
          <kendo-pager-next-buttons></kendo-pager-next-buttons>
          <kendo-pager-page-sizes [pageSizes]="pagerConfig.sizes"></kendo-pager-page-sizes>

          <span class="grid-refresh-button k-icon k-i-reload-sm" (click)="refreshGridClicked()"></span>
          <div class="k-pager-info">{{pagerInfoMessage}}</div>

        </ng-template>

      </kendo-grid>
    </div>
  </div>

</div>
